export const StepFields = [
    ['firstName', 'borrowerType', 'noApplicants', 'noAdults', 'noChildren', 'noYoungChildren'],
    ['basicSalary', 'guaranteedBonus', 'regularBonus'],
    [
        'netMonthlyIncome',
        'childBenefit',
        'childTaxCredit',
        'workingTaxCredit',
        'childMaintenance',
        'pension',
    ],
    [
        'creditCards',
        'creditCardPayments',
        'personalLoans',
        'hirePurchase',
        'carFinance',
        'netStudentLoans',
        'grossStudentLoans',
        'childcare',
        'otherMortgages',
        'maintenance',
        'groundRent',
        'housingAssociation',
        'other',
    ],
    ['propertyLocation', 'mortgageTerm', 'purchasePrice', 'borrowingAmount'],
];
export const IncomeWeighting = [
    { name: 'childBenefit', weight: 0.5 },
    { name: 'childTaxCredit', weight: 0.5 },
    { name: 'workingTaxCredit', weight: 0.5 },
    { name: 'childMaintenance', weight: 0.5 },
    { name: 'pension', weight: 1 },
];
export const ExpenditureWeighting = [{ name: 'netStudentLoans', weight: 0 }];
